import {SuccessesGreenIcon} from "@/app/[locale]/common/assets/SuccessesGreenIcon/SuccessesGreenIcon";
import {ErrorRedColor} from "@/app/[locale]/common/assets/ErrorRedColor/ErrorRedColor";

export const ADMIN_MESSAGES = {
    SUCCESS_DESCRIPTIONS: {
        AUTH: 'You are logged in as eric-admin-edjr.',
        CREATE_ADMIN: 'New eric-admin-edjr created.',
        GET_USERS: 'All users received.',
        REMOVE_ADMIN: 'The eric-admin-edjr has been removed.',
    },
    SUCCESS: {
        title: 'Success',
        Icon: SuccessesGreenIcon,
    },
    ERROR: {
        title: 'Error',
        description: 'Something went wrong. Please, try again!',
        Icon: ErrorRedColor,
    },
};